/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "Add"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "Remove all"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enIN = Object.assign(TranslationProviderComponent, {
  translations
});

export { enIN as e };
//# sourceMappingURL=en-IN-Qhg6eAuK.js.map
